import 'moment/locale/cs.js';
import { ITranslationForMts } from './translationInterface';

export const csCzForMts: ITranslationForMts = {
    //routes
    route_PrematchHome: 'cz',
    route_TopBetsMobile: 'top',
    route_HomeTopBetsDesktop: 'nejsazenejsi',
    route_HomeLiveDesktop: 'live',
    route_HomeHotBetsDesktop: 'hotbets',
    route_HomeTicketOfDayDesktop: 'tiket-dne',
    route_HomeTopOfferDesktop: 'top-nabidka',
    route_SportsList: 'sporty',
    route_StandardEvents: 'zapasy',
    route_StandardEventDetail: 'zapas',
    route_LiveEvents: 'live-zapasy',
    route_LiveEventDetail: 'live-zapas',
    route_CashOut: 'prodej',
    route_BetDetail: 'muj-tiket',
    route_BetDetailPublic: 'tiket',
    route_LegacyTicketDetailPublic: "tiketl",
    route_BetList: 'moje-tikety',
    route_BetListVG: 'moje-tikety-vh',
    route_BetWinList: 'moje-vyhry',
    route_Search: 'hledani',
    route_MarketingAction: 'souteze',
    route_TicketDetail: 'muj-tiket',
    route_TicketDetailVG: 'muj-tiket-vh',
    route_TicketDetailByNumber: 'najdi-tiket',
    route_Calendar: 'kalendar',
    route_Favorites: 'vybrane',
    route_Top5Bets: '',
    route_Top10Bets: '',
    //
    no_categories: 'Žádné kategorie.',
    today: 'Dnes',
    tomorrow: 'Zítra',
    yesterday: 'Včera',
    weekend: 'Víkend',
    todayTomorrow: 'Dnes, zítra ',
    by_date: 'Podle datumu',
    by_time: 'Podle času',
    by_week_day: 'Podle dní',
    hour: 'hodina',
    three_hours: 'hodiny',
    hours: 'hodin',
    more: 'Víc',
    available_tips: 'Tipy',
    date: 'Uzavření',
    game: 'Sázková příležitost',
    deposit: 'Vklad:',
    eventual_winnings: 'Možná výhra:',
    detail: 'Detail',
    other: 'Další',
    less: 'Méně',
    all: 'Všechno',
    result: 'Výsledek',
    statistics: 'Statistiky',
    search: 'Hledej …',
    no_results: 'Seznam je prázdný',
    detail_not_found: 'Detail nenalezen',
    back: 'Zpět',
    next: "Další",
    final_rate: 'Výsledný kurz:',
    finished: 'Ukončené',
    match: 'Zápas',
    bet: 'Tip',
    rate: 'Kurz',
    ticket_code: 'Kód tiketu',
    state: 'Stav',
    date_paid: 'Dátum a čas uzavření tiketu',
    stake: 'Vklad',
    eventual_win: 'Možná výhra',
    ticket_type: 'Druh podaného tiketu',
    bet_type: 'Typ sázky',
    channel: 'Zdroj',
    ticket_detail: 'Detail tiketu',
    prize_paid: 'Výsledná výhra',
    win_paid: 'K výplatě',
    ticket_public_link: 'URL k veřejnému zobrazení tiketu:',
    refresh: 'Aktualizovat',
    download_file: 'Stáhnout dokument',
    combination: 'kombinace',
    combinations_0: 'kombinací',
    combinations_few: 'kombinace',
    combinations_more: 'kombinací',
    combination_short: 'komb.',
    event_no_longer_available: 'Událost už není aktivní.',
    has_to_be_logged_in: 'Pro výběr kategorie musíte být přihlášeni.',
    something_went_wrong: 'Chyba na stránce.',
    no_events_for_filter: "Žádné události nevyhovují zadanému filtru.",
    no_events_or_leagues_found: "Žádné události nebo ligy neboli nalezené pro zadaný text.",
    search_searchEventTitle: "Hledání",
    flag_new: "nové",

    // --------------------- general
    general_BtnMore: "Víc",
    general_Loading: 'Nahrávám...',
    general_OddsDraw: "Remíza",
    general_EventGameGroupOther: "Ostatní",
    general_EventLiveTag: "LIVE",
    general_CriticalRenderError: 'Chyba na stránce.',
    general_CriticalRenderRefreshBtn: 'Pokračovat',
    general_CriticalRenderHomeBtn: 'Úvodní stránka',
    general_ProgressContentError: 'Chyba při načítání, zkuste prosím znovu',
    general_ErrorInInitialization: 'Chyba při inicializaci',
    general_SessionExpired: 'Session vypršela',

    // ---------------------- menu
    menu_Top: "Top",
    menu_Prematch: "Sázky",
    menu_Live: "LIVE",
    menu_Cashout: "CASHOUT",
    menu_Search: "Hledat",
    menu_Time: 'Čas',

    // --------------------- live-menu
    liveMenu_overview: "Přehled",
    liveMenu_favourites: "Vybrané",
    liveMenu_event: "Událost",
    liveMenu_calendar: "Kalendář",

    //------------------- topBets
    topbets_TopBetsTitle: "Nejsázenější",
    topbets_HotBetsTitle: "TOP zápasy dne",
    topbets_NoResults: "Seznam je prázdný",
    topbets_Top5Title: "TOP 5",
    topbets_Top10Title: "TOP 10",

    //  ---------------------- prematch
    prematch_NoEventsForFilter: "Pro zadaný filtr neexistují žádné události.",
    prematch_SportListTitle: "NABÍDKA SPORTŮ",
    prematch_SportListNoSport: "Pro zadaný časový interval neexistují žádné události.",
    prematch_TimeFilterAll: "Vše",
    prematch_TimeFilterToday: "Dnes",
    prematch_TimeFilterTodayTomorrow: "Dnes,zítra",
    prematch_TimeFilterWeek: "Týden",
    prematch_TabOdds: "Kurzy",
    prematch_TabStats: "Statistiky",
    prematch_EventNotExists: "Událost už není v nabídce.",
    prematch_EventListSectionTop: "TOP",
    prematch_EventListSectionOthers: "Ostatní",
    prematch_EventAvailableAsLive: "Zápas začal, přejdi do LIVE.",

    prematch_MobileExpandMoreVMT: "+ Víc",
    prematch_MobileCollapseMoreVMT: "- Méně",

    // --------------------- live offer
    live_noRates: "Kurzy momentálně nedostupné.",
    live_seeOddsInDetail: "Vsaďte si na příležitosti v detailu události",
    live_EventHasEnded: "Událost už není v nabídce.",
    live_OtherEventsBtn: "Jiné události",
    live_TabOdds: "Kurzy",
    live_TabMatchTracker: "Animace",
    live_TabMatchTrackerStats: "Statistiky",
    live_TabVideo: "Video",
    live_NoEvents: "Aktuálně neprobíhají žádné události.",
    live_BaseballCurrentHalfInningStat: "STATISTIKA AKTUÁLNÍ PŮLSMĚNY",
    live_AmFootballAttackTeamStat: "STATISTIKA ÚTOČÍCÍHO MUŽSTVA",
    live_TimelineTitle: "VÝVOJ ZÁPASU",
    live_TimelineDesktopTitle: "Události v zápasu",
    live_ScoreMainScoreTitle: "Stav",
    live_OddBelowName: "Pod",
    live_Favorites: "Vybrané",
    live_NoFavorites: "Žádné vybrané události.",

    live_WarrantyInfo: "Uvedené časové a statistické údaje jsou pouze orientační. Společnost SYNOT TIP a.s. neručí za správnost a aktuálnost zobrazovaných informací (např. aktuální skóre). Na základě těchto údajů nelze uznat případné reklamace.",

    // ------------------------------ desktop live
    desktopLive_OpenEvents: "Právě live",
    desktopLive_FavoriteEvents: "Vybrané",
    desktopLive_NoFavoriteEvents: "Není vybraný žádný zápas. Zápasy vyberete kliknutím na hvězdičku v levém sloupci nebo na úvodní stránce",

    //--------------------- coupon

    coupon_commonError: "Sázenka obsahuje chybné tipy.",

    coupon_LoginForSend: "Přihlaste se pro podání",
    coupon_UpdatingSystem: "aktualizuji ...",
    coupon_CouponGeneralError: "Došlo k chybě při zpracování",
    coupon_CouponExpectedNotSystemError: "Interní chyba při zpracování, vymažte tiket a přidejte tipy znovu",
    coupon_CopyGeneralError: "Došlo k chybě při přípravě kopie tiketu",
    coupon_StakeInputError: "Hodnota pro vklad není správně zadaná",
    coupon_TicketListCombination: "KOMBINACE",
    coupon_TicketListStake: "VKLAD",
    coupon_TicketListRate: "KURZ",
    coupon_TicketListPotentialWin: "MOŽNÁ VÝHRA",
    coupon_SystemSwitchLabel: "KOMBI",

    coupon_HeaderSystemCouponSetting: "Nastavení systémového tiketu",
    coupon_StakeTypeCoupon: "KUPÓN",
    coupon_StakeTypeSystem: "SYSTÉM",

    coupon_SummaryPricePotential: "Možná výhra",
    coupon_Stake: "Vklad",
    coupon_MaxStake: "max.",
    coupon_TotalRate: "Výsledný kurz",
    coupon_StakeForOneTicketInSystem: "Vklad na sázku",
    coupon_AverageRate: "Průměrný kurz",

    coupon_SentSuccessMessage: "Vaše sázka byla přijatá. Děkujeme.",
    coupon_SentRejectMessage: "Podání tiketu bylo zamítnuté",
    coupon_CopyTicket: "Stejný tiket",
    coupon_NewTicket: "Nový tiket",

    coupon_evaluateBtn: "Přepočítat",
    coupon_acceptRateChangeBtn: "Akceptovat",
    coupon_sendToPay: "Podat",

    coupon_liveAcceptHigerRate: "Přijmout vyšší kurz",
    coupon_liveAcceptAllRates: "Přijmout jakýkoliv kurz",
    coupon_liveHint_Question: "Doporučená výška vkladu na Vaši sázku je {value}. Souhlasíte?",
    coupon_liveHint_Yes: "Ano",
    coupon_liveHint_No: "Ne",

    coupon_TypePrematch: "Standard",
    coupon_TypeLive: "Live",

    coupon_OddTitle: "Tip",
    coupon_AddPublicLinkToChat: "Vložit odkaz do chatu",

    // -------------------- ticket
    ticket_TicketTabLabel: "Tiket",
    ticket_BettingTicket: "Sázkový tiket",
    ticket_SelectionCount: "Počet tipů",
    ticket_StakeTypeAll: "KUPÓN",
    ticket_StakeTypeUnit: "KOMBI",
    ticket_StakeTypeTotal: "SYSTÉM",
    ticket_OddTitle: "Tip",
    ticket_BankerTitle: "Tutovka",
    ticket_HasErrors: "Tiket obsahuje chyby",
    ticket_TicketTypeSimple: "Jednoduchý", //--Simple
    ticket_TicketTypeSystem: "Kombi",  //--System
    ticket_TicketTypeVGSplit: "-",
    ticket_TicketTypeVGCombi: "-",
    ticket_EvalTypeLost: "Nevýherní",
    ticket_EvalTypeWin: "Výherní",
    ticket_EvalTypeCancelledWithMP: "Zrušený",
    ticket_EvalTypeCancelled: "Zrušený",
    ticket_EvalTypeCashout: "Prodaný",
    ticket_NoTips: "Váš tiket neobsahuje žádné tipy.",
    ticket_Ticket: 'Tiket',
    ticket_TicketStateSettled: "Vyhodnocený",
    ticket_TicketStateStorno: "Stornovaný",
    ticket_TicketStateStornoBySystem: "Stornovaný",
    ticket_TicketStateStornoByMts: "Nepřijatý",
    ticket_TicketStateCommonAccepting: "Zpracovává se",
    ticket_TicketStateCommonAccepted: "Přijatý",
    ticket_Login: "Přihlašte se pro zobrazení tiketu.",
    ticket_Calculations: "Přehled kombinací",
    ticket_NotFound: "Tiket nenalezen",
    ticket_TicketOfNumberNotFound: "Tiket {number} nebyl nalezen",
    ticket_Group: "Sk.",
    ticket_CashoutTab: "Cashout",
    ticket_PrepareTicket: "Připravit sázenku",
    ticket_SelectionResult: "Výsledek",

    ticket_ReuseOddsTicketBtn: "Přidat na nový tiket",
    ticket_ReuseOddsGeneralError: "Nepodařilo se přidat tipy na tiket, zkuste to znovu prosím.",
    ticket_ReuseOddsNotAllAddedError: "Některé tipy nebylo možné přidat na tiket, protože již nejsou v nabídce.",

    //my-tickets
    myTickets_NoTicket: 'Žádné tikety',
    myTickets_Login: "Přihlašte se pro zobrazení tiketů.",
    myTickets_ColumnPotentialPrice: 'Výhra',
    myTickets_TypeSports: "Kurzové sázky",
    myTickets_TypeVirtualGames: "Virtuální hry",

    //Mobile App advert
    mobileAppAdvert_title: "Mobile Sports apps",

    // ---------------------- bet detail
    bet_TicketIdTitle: "Kód tiketu",
    bet_TicketStateTitle: "Stav",
    bet_TicketReasonTitle: "Důvod",
    bet_TicketDatePaid: "Datum a čas uzavření tiketu",
    bet_System: "Systém",
    bet_Stake: "Vklad",
    bet_TotalRate: "Výsledný kurz",
    bet_PotentialPrice: "Možná výhra",
    bet_FinalWin: "Výsledná výhra",
    bet_ToPayout: "K výplatě",
    bet_TicketType: "Druh podaného tiketu",
    bet_BetType: "Typ sázky",
    bet_CanBeCancelledUntil: "Tiket je možné stornovat do",
    bet_Channel: "Zdroj",
    bet_Match: "Zápas",
    bet_Tip: "Tip",
    bet_TipWinTip: "Tip / Výherní tip",
    bet_TipTicketDetail: "Tip",
    bet_Sum: "Suma",
    bet_PossibleWinFrom: "Možná výhra od",
    bet_PossibleWinTo: "Možná výhra do",
    bet_Errors: 'Chyby',
    bet_HandlingFee: "Man. poplatek",
    bet_ProductFee: "Poplatek za produkt",
    bet_ProductName: "Produkt",
    bet_OddsRateAdvantage: "Zvýhodněný kurz",
    bet_RateAdvantageFactor: "Kurzové zvýhodnění",
    bet_FreeTicketSection: "Sázka zdarma",

    bet_Header: "Detail tiketu",
    bet_SuccessfulCashout: "Tiket byl prodaný",
    bet_ErrorDuringCashout: "Nepodařilo se prodat tiket",
    bet_ReallyCashoutBetOfValue: "Opravdu chcete predčasně vyplatit tiket za {value} ?",

    bet_PublicLink: "URL k veřejnému zobrazení tiketu",
    bet_TransferToCredit: "Převod na kredit",
    bet_TransferToBank: "Převod do banky",

    bet_CopyConfirmYes: "Ano",
    bet_CopyConfirmNo: "Ne",
    bet_CopyConfirmQuestion: "Pro podání za nižší vklad je nutné přepsat aktuální tiket. Souhlasíte?",
    bet_CopyConfirmTitle: "SÁZKOVÝ TIKET",

    bet_AgreeWithLowerAmount: "Souhlasíte se sníženou částkou?",
    bet_Cashout: "Vyplatit",
    bet_ErrorInTicketListLoad: "Chyba při načtení seznamu tiketů",

    bet_CancelUntil: 'Tiket je možné stornovat do',
    bet_CancelSuccess: 'Ticket has been cancelled.',
    bet_CancelError_AlreadyCancelled: 'Ticket has been already cancelled',
    bet_CancelError_PeriodOver: 'Time limit for cancellation has passed.',
    bet_CancelError_NotForThisPlayer: 'Ticket is for another player.',
    bet_CancelError_GeneralError: 'Cancellation error',
    bet_CancelBetBtnCancelTitle: "Cancel",

    coupon_CashoutAcceptHigerRate: "Accept higher amount",
    coupon_CashoutAcceptAllRates: "Accept any amount",
    coupon_cashoutButton: "Cashout for {value}",

    // ---------------- cashoutList
    cashoutList_ColumnTime: "čas",
    cashoutList_ColumnStake: "vklad",
    cashoutList_ColumnPotentialPrice: "Výhra",
    cashoutList_ColumnSell: "Prodej",
    cashoutList_NoTickets: "Zatím nemáte tikety na prodej.",
    cashoutList_Login: "Přihlašte se pro zobazení tiketů na prodej.",
    cashoutList_LoadAgain: "Znovu",

    //--------------------- betList
    betList_TicketNumber: 'Kód tiketu',
    betList_ColumnTime: "Datum",
    betList_ColumnStake: "Vklad",
    betList_ColumnPotentialPrice: "Ev.výhra",
    betList_ColumnPricePotentialPrice: "Ev.výhra/výhra",
    betList_ColumnStatus: "Stav",
    betList_ColumnDetail: "Detail",

    //--------------------- ticketList
    ticketList_TimeFilter_None: "-vše-",
    ticketList_TimeFilter_Day: "Den",
    ticketList_TimeFilter_ThreeDays: "Tři dny",
    ticketList_TimeFilter_Week: "Týden",
    ticketList_TimeFilter_TwoWeeks: "2 týdny",
    ticketList_TimeFilter_Month: "Měsíc",

    ticketList_StateFilter_None: "-vše-",
    ticketList_StateFilter_Accepted: "Přijatý",
    ticketList_StateFilter_Win: "Vyhraný",
    ticketList_StateFilter_Loss: "Prohraný",
    ticketList_StateFilter_CancelWithHandlingFee: "Zrušený",
    ticketList_StateFilter_Cashout: "Prodaný",
    ticketList_StateFilter_Storno: "Stornovaný",

    ticketList_OfferTypeFilter_None: "-vše-",
    ticketList_OfferTypeFilter_Prematch: "Standard",
    ticketList_OfferTypeFilter_Live: "Live",

    ticketList_Title: "Přehled tiketů",
    ticketList_TimeFilterTitle: "Časové období",
    ticketList_StateFilterTitle: "Stav",
    ticketList_OfferTypeFilterTitle: "Typ sázky",
    ticketList_FilterSubmit: "Zobrazit",

    // ------------- ticket detail
    bet_FinalScoreInfo: "U sportů, kde může dojít k prodloužení nebo penaltovému rozstřelu, je finální výsledek uvedený včetně případného prodloužení a penaltového rozstřelu.",

    //-------------------- search
    search_FillSomethingInfo: "Zadejte název události nebo ligy",
    search_LastSearch: "Poslední hledání:",
    search_ResultEvents: "Zápasy",
    search_ResultLeagues: "Ligy",
    search_NothingFound: "Nenašli jsme takový zapas nebo ligu.",
    search_InProgress: "Hledám ...",

    // ----------------- offline
    offline_InfoText: "Přerušení připojení k internetu nebo na server",
    offline_TryReconnect: "Zkusit připojit znovu",

    // ------------ recommended
    recommended_title: "Doporučujeme",

    // ----------- marketing action
    marketingAction_NoAction: "Akce nebyla nalezená",
    marketingAction_Next: "Další",
    marketingAction_Less: "Méně",

    // ----------- mobile QR code
    mobileAppLinkAdvert_Header: "Mobilní aplikace",

    //--------- live stream / matchtracker
    liveStream_Opening: "Otvírám ...",
    liveStream_ErrorOpening: "Nepodařilo se otevřít video.",
    liveStream_NeedToLogin: "Pro zobrazení live přenosu musíte být přihlášeni.",
    liveStream_NeedLiveStreamAccess: "Pro zobrazení live přenosu musíte mít dokončenou registraci.",
    liveStream_NotPlayedNow: "Live přenos zatím není k dispozici. Začátek je %1.",
    liveStream_NotAvailableFormat: "Nepodařilo se otevřít video. Začátek je %1.",
    liveStream_TryAgain: "Zkuste znovu",
    liveStream_NoVideoForThisPart: "Nepodařilo se otevřít video.",
    livestream_Login: "login",

    // -------- live notifications
    liveNotification_ErrorOnUpdate: "Nepodařilo se aktualizovat nastavení",
    liveNotification_Header: "Live upozornění k události",
    liveNotification_AllowRequestText: 'Povolit notifikace v nastavení vašeho zařízení.',
    liveNotification_AllowRequestButton: 'Povolit',
    liveNotification_NeedAllowInBrowserPermissions: "Pro příjem informací o zápase musíte povolit ve svém prohlížeči notifikace.",

    //right column
    rightColumn_MyBetsToday: "MOJE DNEŠNÍ SÁZKY",
    rightColumn_NoBetsToday: "Dnes ještě nemáte podaný tiket",
    rightColumn_LoadAgain: "Znovu",

    //find ticket by number
    findTicketByNumber_title: "KONTROLA TIKETU",
    findTicketByNumber_InfoText: "Zadejte tu prosím číslo sázenky nad čárovým kódem:",
    findTicketByNumber_buttonSend: "Kontrola",
    findTicketByNumber_Placeholder: "Číslo sázky",

    //chat
    chat_WriteMessagePlaceholder: "vaše zpráva...",  //chat.yourMessage
    chat_SendMessage: "Odeslat", //chat.sendMessage
    chat_Sending: "Odesílám ...", //chat.sendingText
    chat_LoginToSendMessage: "Pro odeslání zprávy se musíte přihlásit...",  //chat.loginToSendMessageInfo
    chat_LoadingMessages: "nahrávám zprávy",
    chat_ErrorLoadingMessagesAgainBtn: "Znovu",  //chat.btnErrorLoadingMessagesAgain
    chat_ErrorLoadingMessage: "Nepodařilo se nahrát zprávy",  //chat.errorLoadingMessages
    chat_PrivateReply: "Soukromá zpráva",//chat.privateReply     // cjuba "Uživatelé mi můžou psát privátně",  //chat.acceptAllUsers
    chat_PublicReply: "Veřejná odpověď",  //chat.publicReply
    chat_AcceptAllUsers: "Uživatel mi může psát soukromě",  //chat.acceptAllUsers
    chat_BlockAllUsers: "Nikdo mi nemůže psát soukromě",  //chat.blockAllUsers
    chat_BlockedUser: "Uživatel mi může napsat soukromou zprávu", //chat.blockedUser
    chat_NonblockedUser: "Uživatel mi může napsat soukromou zprávu",
    chat_NeedNickname: "Nemáte žádnou přezdívku. Chat vám bude zpřístupněný po zadání přezdívky v profilu hráče.",
    chat_AnswerForTitle: "Odpověď pro",
    chat_ChatSendMessage_Success: "Zpráva byla uložená",  //chat.sendMsgOk
    chat_ChatSendMessage_NonExistentReply: "Zpráva na kterou odpovídáte neexistuje",  //chat.sendMsgNoSourceMsg
    chat_ChatSendMessage_PrivateBlocked: "Uživatel si zablokoval soukromé zprávy",  //chat.sendMsgBlockedPrivate
    chat_ChatSendMessage_TimeConstraintFailed: "Je nutné počkat %1 sekund od poslední zprávy", //chat.sendMsgProtection
    chat_ChatSendMessage_UserBanned: "Uživatel má zakázané posílat zprávy",  //chat.sendMsgBanned
    chat_ChatSendMessage_UserNotLogged: "Nejste přihlášeni",  //chat.sendMsgNotLogged
    chat_ChatSendMessage_Fail: "Chyba při odesílání zprávy",  //chat.sendMsgError

    //saved ticket  // netreba prekladat do SK a CZ, pouziva sa iba v LV
    savedTicket_header: 'Notice',
    savedTicket_thanks: 'Your bet has been saved. Thank you.',
    savedTicket_p1: 'You can place your bet at any of the over-the-counter betting centres using the number',
    savedTicket_p2: 'Bets cannot be placed once the taking of bets for the given prediction has closed, or after',
    savedTicket_warning: 'Place your bets as soon as you can! The odds in the offer frequently change and bets can be rejected because of a change in the odds.',
    savedTicket_identicalBet: 'Identical bet',

    //calendar
    calendar_startTime: 'začátek',
    calendar_event: 'událost',
    calendar_category: 'kategorie',

    //upcoming events
    upcomingEvents_label: 'dnes následuje',

    //favorites
    my_favorites: "Moje",

    //live Favorites
    liveFavorites_showMoreDetails: "Zobrazit další nabídku",
    liveFavorites_hideMoreDetails: 'Skrýt další nabídku',

    //OTB
    otb_Switch: 'Rychlá sázka',
    otb_InfoText: 'Aktivací a nastavením rychlé sázky můžete podat sólo sázku pouhým kliknutím na kurz vybrané příležitosti.',
    otb_InfoWarning: "Pro aktivaci Rychlé sázky, prosím, potvrdte nastavení.",
    otb_SettingHeader: "Nastavení Rychlé sázky:",
    otb_FirstPage_Cancel: "Zrušit",
    otb_FirstPage_Confirm: "Potvrdit",
    otb_TurnOffOTB: "Vypnout Rychlé sázky:",
    otb_CancelBetslip: "Zrušit tiket",
    otb_Sending: "Podávám",

    // rate filter
    rateFilter_Title: "Kurz",
    rateFilter_From: "Od",
    rateFilter_To: "Do"
};
